import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { CardsComponent } from './cards/cards.component';
import { LoginComponent } from './login/login.component';
import { OauthGuard } from './guards/oauth.guard';
import { AlarmsComponent } from './alarms/alarms.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { IndicesComponent} from './indices/indices.component';
import { HistoryComponent } from './history/history.component';
import { EficiencyComponent } from './eficiency/eficiency.component';
import { ControlsComponent } from './controls/controls.component';
import { ComparativesComponent } from './comparatives/comparatives.component';
import { ResumeComponent } from './resume/resume.component';
import { DeuComponent } from './deu/deu.component';
import { DatainputComponent } from './datainput/datainput.component';
import { PlanillasComponent } from './planillas/planillas.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent, canActivate: [OauthGuard] },
  { path: 'cards', component: CardsComponent, canActivate: [OauthGuard]},
  { path: 'deu', component: DeuComponent, canActivate: [OauthGuard]},
  { path: 'data-input', component: DatainputComponent, canActivate: [OauthGuard]},
  { path: 'login', component: LoginComponent },
  { path: 'alarms', component: AlarmsComponent, canActivate: [OauthGuard]},
  { path: 'resume', component: ResumeComponent, canActivate: [OauthGuard]},
  { path: 'indices', component: IndicesComponent, canActivate: [OauthGuard]},
  { path: 'history', component: HistoryComponent, canActivate: [OauthGuard]},
  { path: 'eficiency', component: EficiencyComponent, canActivate: [OauthGuard]},
  { path: 'comparatives', component: ComparativesComponent, canActivate: [OauthGuard]},
  { path: 'controls', component: ControlsComponent, canActivate: [OauthGuard]},
  { path: 'planillas', component: PlanillasComponent, canActivate: [OauthGuard]},
  { path: '404', component: NotFoundComponent },
  { path: '**', redirectTo: '404'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
